<!-- @format -->
<div
	class="checkbox-container hmf-position-relative hmf-pr-xxs"
	[class]="showMore() ? 'view-less' : 'view-more'">
	@for (filterOption of processedFilterOptions(); track trackFilterName(filterOption.option)) {
		<plp-components-filter-option
			[class]="!allowCollapsing() && $last ? '' : 'hmf-mb-xxs'"
			[filterOption]="filterOption.option"
			[attributeName]="attributeName()"
			[attributeIdentifier]="attributeIdentifier()"
			[isMobile]="isMobile()"
			[disabled]="disabled()"
			[displayValue]="displayValues()[$index]"
			[ariaLabel]="ariaLabels()[$index]"
			[selectedOptions]="selectedOptions()"
			[filterOptionType]="FilterOptionType.Radio"
			[labelAsHmfInputContent]="true"
			(setSelectedFilter)="setSelectedFilter($event)"
			(setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
			<ng-template #projectedLabel>
				<div class="hmf-display-flex hmf-flex-row hmf-align-items-flex-start hmf-body-m">
					<hmf-star-ratings
						[ratingValue]="filterOption.numericValue"
						[size]="'medium'"
						[showRating]="false"
						[showReviewCount]="false"
					></hmf-star-ratings>
					@if (filterOption.extraText) {
						<div class="hmf-ml-xxxs" [class.is-disabled]="disabled()">
							{{ filterOption.extraText }}
						</div>
					}
				</div>
			</ng-template>
		</plp-components-filter-option>
	}
</div>
